export default __webpack_public_path__ + "cd1b334b5b3468a20b9b49e584d18bba.svg";